import { SearchOutlined } from '@ant-design/icons';
import { Empty, Layout } from 'antd';
import { fetchAllOrgs, setCurrentOrg } from 'app-redux/actions/org.actions';
import { AppState } from 'app-redux/reducers';
import { getOrgsList } from 'app-redux/selectors/orgs.selector';
import farmImage from 'assets/images/illustration_organizations.svg';
import { iff } from 'core/iff';
import { INavigationRouteProps } from 'core/navigation/models';
import { OrganizationDTO } from 'core/orgs/models';
import { PageDTO, UUID } from 'core/utils/BasicModels';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { SegmentService } from 'services/SegmentService';
import styled from 'styled-components';
import { Input, Typography } from 'syngenta-digital-cropwise-react-ui-kit';
import { translationWrapper } from 'utils/common-methods';
import { OrgCardComponent } from './OrganizationCard';
import './style.less';
const { Content } = Layout;

const FlowDivContainer = styled(Content)`
  background-color: #F5F8FC;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const { Text } = Typography;

interface IHallOfOrgsProps extends INavigationRouteProps<{}> {
  orgList: OrganizationDTO[];
  fetchOrgs?: () => Promise<PageDTO<OrganizationDTO>>;
}

const HallOfOrgs: React.FC<IHallOfOrgsProps> = (props) => {
  const { t } = translationWrapper(useTranslation(), false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    SegmentService().page('Hall of Orgs page');
    if (props.fetchOrgs) {
      props.fetchOrgs().catch();
    }
  }, []);

  const filterByTerm = (orgsList: OrganizationDTO[], term: string) => {
    return orgsList.filter((org) => {
      const value = org.name;
      return iff(
        value !== '',
        value.toLowerCase().includes(term.toLowerCase()),
        undefined,
      );
    });
  };

  const showFilteredOrgs = (orgsList: OrganizationDTO[], term: string) => {
    const filteredOrgList = filterByTerm(orgsList, term);

    return iff(
      filteredOrgList.length > 0,
      filteredOrgList.map((org) => (
        <OrgCardComponent key={org.id} id={org.id} name={org.name} />
      )),
        (
            <div className={'cw-empty-orgs'}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
        ),
    );
  };

  return (
      <FlowDivContainer>
        <div className={'cw-my-orgs-placeholder'}>
          <div className={'cw-org-searchbox'}>
            <div className={'cw-org-title'}>
              <Text strong={true} style={{ fontSize: '20px', color: '#2F3031' }}>{t('My Organizations')}</Text>
            </div>
            <div className={'cw-org-search'}>
              <Input
                placeholder={t('Search by name')}
                size="large"
                maxLength={50}
                prefix={<SearchOutlined />}
                onChange={(e) => setSearchTerm(e.target.value)}
                allowClear={true}
                value={searchTerm}
              />
            </div>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {searchTerm === '' ?
              props.orgList.map((org) => (
                <OrgCardComponent key={org.id} id={org.id} name={org.name} />
              )) :
              showFilteredOrgs(props.orgList, searchTerm)
            }
          </div>
        </div>
        <div className={'cw-org-img-placeholder'}>
          <img style={{ width: '100%' }} src={farmImage} />
        </div>

      </FlowDivContainer>

  );
};

const mapStateToProps = (state: AppState) => ({
  orgList: getOrgsList(state),
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchOrgs: () => dispatch(fetchAllOrgs()),
    setCurrentOrg: (orgId: UUID) => dispatch(setCurrentOrg(orgId)),
  };
};

export const HallOfOrgsComponent = withRouter(connect(mapStateToProps, mapDispatchToProps)(HallOfOrgs));
